export default __webpack_public_path__ + "3f7acfe50aad7ad685484df2f44c6e75.ttf";